import { render, staticRenderFns } from "./crudPages.vue?vue&type=template&id=0fcc2d90&scoped=true&"
import script from "./crudPages.vue?vue&type=script&lang=js&"
export * from "./crudPages.vue?vue&type=script&lang=js&"
import style0 from "./crudPages.vue?vue&type=style&index=0&id=0fcc2d90&prod&lang=css&"
import style1 from "./crudPages.vue?vue&type=style&index=1&id=0fcc2d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc2d90",
  null
  
)

export default component.exports